"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProductAutocompleteSelector = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledProductAutocompleteSelector = (0, styled_components_1.default)(ui_components_1.Autocomplete) `
  &.MuiAutocomplete-root > .MuiFormControl-root > .MuiInputBase-root.MuiOutlinedInput-root {
    height: ${({ theme: { spacing } }) => spacing(5.75)};
    min-height: 0px;
    padding: ${({ theme: { spacing } }) => spacing(0.75)};

    .MuiAutocomplete-input {
      padding: ${({ theme: { spacing } }) => spacing(0.3125, 0.5, 0.3125, 0.75)};
    }
  }
`;
